import React from "react";
import InnerPopup from "../Popups/InnerPopup";
import { withTranslation } from "react-i18next";

const ConfirmNicknamePopup = (props) => {
    const { nickname, onClose, onUpdate } = props;


    return (
        <div className="nickname_modal">
            <InnerPopup
                onCloseModal={onClose}
            >
                <div className="nickname_poupcontent">
                    <p>
                        {/* {props.t('Would_you_like_to_continue_using_the_nickname')} */}
                        Apakah anda yakin menggunakan nickname
                        "{nickname}" ?
                    </p>
                    <div className="nickname_poupcontent_btns">
                        <button className="button_secondary" onClick={onUpdate}>
                            KONFIRMASI
                        </button>
                        <button className="button_secondary" onClick={onClose}>
                            BATAL
                        </button>
                    </div>
                </div>
            </InnerPopup>
        </div>
    );
};

export default withTranslation()(ConfirmNicknamePopup);
